import style from "../components/app.css";

export const capitalizeFirstLetter = (word) =>
  word.charAt(0).toUpperCase() + word.slice(1);

export const vendorResultStyle = (showMap) =>
  showMap ? style.vendorResultMap : style.vendorResultList;

export const mapToggleButtonClass = (showMap) => {
  if (isMobileScreen() && showMap) {
    return style.toggleMapButtonLowered;
  } 
  return style.toggleMapButton;
};

export const renderToggleMapText = (showMap) => {
  if (isMobileScreen()) {
    if (showMap) {
      return "Liste";
    }
    return "Karte";
  } else {
    if (showMap) {
      return "Karte ausblenden";
    }
    return "Karte anzeigen";
  }
};

export const renderHeader = (categoryFilter, cityFilter) =>
  getDesktopTitle(categoryFilter, cityFilter);

export const isMobileScreen = () => {
  return typeof window !== "undefined" ? window.innerWidth <= 900 : false;
};

const getDesktopTitle = (categoryFilter, cityFilter) => {
  let title = (categoryFilter.toLowerCase() || "locations");
  if(!["hochzeitsplaner", "hochzeitstorten", "junggesellenabschied", "kirchen", "standesämter", "trauringe", "flitterwochen"].includes(title))
    title = "Hochzeits" + title;
  else
    title = capitalizeFirstLetter(title);
  if (cityFilter && cityFilter.length !== 0) {
    title += ` in ${capitalizeFirstLetter(cityFilter)}`;
  }
  return title;
};

export const getFavouriteIcon = (isFavourited) => {
  if (isFavourited) return style.favouritedVendorIcon;
  return style.unfavouritedVendorIcon;
};
